import { createWebHistory, createRouter } from "vue-router";
import AppLayout from '@/views/Layouts/AppLayout'

/** Dashboard */
import DashboardPage from '@/views/Dashboard/DashboardPage'
import EnterpriseDashboardPage from '@/views/Dashboard/EnterpriseDashboardPage'

/**CLO-Dashboard*/
import EnterpriseProfilePage from "@/views/Enterprise Profile/EnterpriseProfilePage";
import EnterpriseProfile from '@/views/Enterprise-Profile-Page/EnterpriseProfile';
import EnterpriseUsers from '@/views/Enterprise-Users/EnterpriseUsers';
import AgreementTerms from '@/views/Enterprise-Agreement-Terms/AgreementTerms';
import SubscriptionsLicenses from '@/views/Enterprise-Subscriptions-Licenses/SubscriptionsLicenses';
import PactoLegalPage from "@/views/PactoLegal/PactoLegalPage";
/** CLO Users */
import CLOUsersPage from "@/views/CLO Users/CLOUsersPage";
import ViewCLOUserPage from "@/views/CLO Users/ViewCLOUserPage"
import EditCLOUserPage from "@/views/CLO Users/EditCLOUserPage"
/** Tenants */
import TenantsPage from '@/views/Tenants/TenantsPage'
/** Landlords */
import LandlordsPage from '@/views/Landlords/LandlordsPage'
/** Users */
import SingleUserPage from '@/views/Users/SingleUserPage'
/** Invites */
import InvitesPage from '@/views/Invites/InvitesPage'
import EditUserManagementPage from '@/views/User-Management/EditUserManagementPage'
/** Properties */
import HousesPage from '@/views/Properties/HousesPage'
import EditHousePage from '@/views/Properties/EditHousePage'
/** Contracts */
import ContractsPage from '@/views/Contracts/ContractsPage'
import ContractSinglePage from '@/views/Contracts/ContractSinglePage'
import CallbackPage from '@/views/Contracts/CallbackPage'
/** Payments */
import PaymentsPage from "@/views/Payments/PaymentsPage";
/** UserFeedbackPage */
import UserFeedbackPage from "@/views/User-Feedback/UserFeedbackPage";
/** ReportsPage */
import ReportsPage from "@/views/Reports/ReportsPage";
/** Proposals */
import CreateContractProposalPage from '@/views/Contracts/Proposals/CreateContractProposalPage'
import ContractProposalsPage from '@/views/Contracts/Proposals/ContractProposalsPage'
import ContractProposalSinglePage from '@/views/Contracts/Proposals/ContractProposalSinglePage'
import EditContractProposalPage from '@/views/Contracts/Proposals/EditContractProposalPage'
/** Contract Management */
import ContractManagementPage from "@/views/Contract-Management/ContractManagementPage";
/** CLO Proposals */
import CLOProposalsPage from "@/views/CLO-Proposals/CLOProposalsPage";
/** CLO Tenants */
import SupportRequestsPage from "@/views/Support Requests/SupportRequestsPage";
/** CLO Invites */
import CLOCommunicationPage from "@/views/CLO Communications/CLOCommunicationPage";
/** CLO Contracts*/
import CLOContractsPage from "@/views/CLO-Contracts/CLOContractsPage";
/** Templates */
import ContractTemplatesPage from '@/views/Contracts/Templates/ContractTemplatesPage'
/** Issues */
import IssuesPage from '@/views/Contracts/Issues/IssuesPage'
import IssuesSinglePage from '@/views/Contracts/Issues/IssuesSinglePage'
/**Chats*/
import ChatsPage from "@/views/Chats/ChatsPage";
/** Profile */
import ProfilePage from '@/views/Profile/ProfilePage'
/** Subscription */
import SubscriptionPage from "@/views/CLO-Subscription/SubscriptionPage";
/** Login */
import LoginView from '@/views/Auth/LoginView'
/** Logout */
import LogoutView from '@/views/Auth/LogoutView'
/** Sign Up */
import SignupView from '@/views/Auth/SignupView'
/** CLO Privacy policy*/
import PrivacyPolicyPage from "@/views/CLO-Privacy-Policy/PrivacyPolicyPage";
/** Support*/
import SupportPage from "@/views/Support/SupportPage";
/** CLO Property Owners*/
import OrganizationProfilePage from "@/views/Organization Profile/OrganizationProfilePage";
/** CLO common page*/
import OrganizationCLOCommonPage from "@/views/OrganisationCLOCommon/OrganizationCLOCommonPage";
/**Settings*/
import SettingsPage from "@/views/Settings/SettingsPage";
/** Users*/
import UsersPage from "@/views/Users-CLO/UsersPage";
/** CLO Settings*/
import CLOSettingsPage from "@/views/CLO-Settings/CLOSettingsPage";
/** Forgot Password */
import ForgotPasswordView from '@/views/Auth/ForgotPasswordView'
/** Legals */
import PrivacyPolicyView from '@/views/Public/PrivacyPolicyView'
/** Reports CLO */
import CLOReportsPage from "@/views/CLO-Reports/CLOReportsPage";
/** CLO Chats*/
import CLOChatsPage from "@/views/CLO-Chats/CLOChatsPage";
/** Deep Links */
import VerifyEmailView from '@/views/Public/VerifyEmailView'
import ResetPasswordView from '@/views/Public/ResetPasswordView'
import ConversationPage from '@/views/Conversations/ConversationPage'
import MoveInMoveOutPage from '@/views/Move In Move Out/MoveInMoveOutPage'
import CLOSupportRequest from '@/views/CLO Support Request/CLOSupportRequest'
import ApplicationsForSupportPage from '@/views/Applications For Support/ApplicationsForSupportPage'
import GDPRRequestsPage from '@/views/GDPR Requests/GDPRRequestsPage'
import HintsAndTipsPage from '@/views/Hints And Tips/HintsAndTipsPage'
import SupportSectionContent from '@/views/Support Section Content/SupportSectionContent'
import FAQPage from '@/views/FAQ/FAQPage'
import WordAndPhaseBlacklistingPage from '@/views/Word and Phase Blacklisting/WordAndPhaseBlacklistingPage'
import RegionsAndCountriesPage from '@/views/Regions and Countries/RegionsAndCountriesPage'
import LanguagesPage from '@/views/Languages/LanguagesPage'
import CurrenciesPage from '@/views/Currencies/CurrenciesPage'
import PactoSettingsPage from '@/views/PactoSettings/PactoSettingsPage'
import CLOListPage from '@/views/CLO List/CLOListPage'

export const router = createRouter({
  history: createWebHistory(),
  linkExactActiveClass: 'active',
  routes: [{
    path: '/',
    redirect: '/dashboard',
    name: 'AppLayout',
    component: AppLayout,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/dashboard',
        name: 'DashboardPage',
        component: DashboardPage,
        meta: {
          title: 'Pacto | Web Dashboard - Dashboard 💼'
        }
      },
      {
        path: '/enterprise/dashboard',
        name: 'EnterpriseDashboardPage',
        component: EnterpriseDashboardPage,
        meta: {
          title: 'Pacto | Web Dashboard - Dashboard 💼'
        }
      }, {
        path: '/tenants',
        name: 'TenantsPage',
        component: TenantsPage,
        meta: {
          title: 'Pacto | Web Dashboard - Tenants 💼'
        }
      },
      {
        path: '/landlords',
        name: 'LandlordsPage',
        component: LandlordsPage,
        meta: {
          title: 'Pacto | Web Dashboard - Landlords 💼'
        }
      },
      {
        path: '/users/:uuid',
        name: 'SingleUserPage',
        component: SingleUserPage,
        meta: {
          title: 'Pacto | Web Dashboard - User 💼'
        }
      },
      {
        path: '/invites',
        name: 'InvitesPage',
        component: InvitesPage,
        meta: {
          title: 'Pacto | Web Dashboard - Invites 💼'
        }
      },
      {
        path: '/chats',
        name: 'ChatsPage',
        component: ChatsPage,
        meta: {
          title: 'Pacto | Web Dashboard - Chats 💼'
        }
      },
      {
        path: '/settings',
        name: 'SettingsPage',
        component: SettingsPage,
        meta: {
          title: 'Pacto | Web Dashboard - Settings 💼'
        }
      },

      {
        path: '/clo-invites',
        name: 'CLOCommunicationPage',
        component: CLOCommunicationPage,
        meta: {
          title: 'Pacto | Web Dashboard - Chats/Communication to chat between admin and clo’s 💼'
        }
      },
      {
        path: '/clo-settings',
        name: 'CLOSettingsPage',
        component: CLOSettingsPage,
        meta: {
          title: 'Pacto | Web Dashboard - Settings 💼'
        }
      },
      {
        path: '/user-management/:uid',
        name: 'EditUserManagementPage',
        component: EditUserManagementPage,
        meta: {
          title: 'Pacto | Web Dashboard - Edit-User-Management 💼'
        }
      },
      {
        path: '/contracts',
        name: 'ContractsPage',
        component: ContractsPage,
        meta: {
          title: 'Pacto | Web Dashboard - Contracts 💼'
        }
      },
      {
        path: '/subscription',
        name: 'SubscriptionPage',
        component: SubscriptionPage,
        meta: {
          title: 'Pacto | Web Dashboard - Subscription 💼'
        }
      },
      {
        path: '/clo-reports',
        name: 'CLOReportsPage',
        component: CLOReportsPage,
        meta: {
          title: 'Pacto | Web Dashboard - Reports 💼'
        }
      },
      {
        path: '/payments',
        name: 'PaymentsPage',
        component: PaymentsPage,
        meta: {
          title: 'Pacto | Web Dashboard - Payments 💼'
        }
      },
      {
        path: '/userfeedback',
        name: 'UserFeedbackPage',
        component: UserFeedbackPage,
        meta: {
          title: 'Pacto | Web Dashboard - User-Feedback 💼'
        }
      },
      {
        path: '/reports',
        name: 'ReportsPage',
        component: ReportsPage,
        meta: {
          title: 'Pacto | Web Dashboard - Reports 💼'
        }
      },
      {
        path: '/contract-management',
        name: 'ContractManagementPage',
        component: ContractManagementPage,
        meta: {
          title: 'Pacto | Web Dashboard - Contract-Management 💼'
        }
      },
      {
        path: '/clo-proposals',
        name: 'CLOProposalsPage',
        component: CLOProposalsPage,
        meta: {
          title: 'Pacto | Web Dashboard - Proposals 💼'
        }
      },
      {
        path: '/clo-contracts',
        name: 'CLOContractsPage',
        component: CLOContractsPage,
        meta: {
          title: 'Pacto | Web Dashboard - Contracts 💼'
        }
      },
      {
        path: '/enterprise',
        meta: {
          title: 'Pacto | Web Dashboard - CLO List  💼'
        },
        children: [
          {
            path: 'clo',
            meta: {
              title: 'Pacto | Web Dashboard - CLO List  💼'
            },
            children: [
              {
                path: ':org/clo-users/:uid',
                name: 'ViewCLOUserPage',
                component: ViewCLOUserPage,
                meta: {
                  title: 'Pacto | Web Dashboard - CLO-Users View 💼'
                }
              },
              {
                path: ':org/clo-users/:uid',
                name: 'EditCLOUserPage',
                component: EditCLOUserPage,
                meta: {
                  title: 'Pacto | Web Dashboard - CLO-Users Edit 💼'
                }
              },
              {
                path: 'organisation',
                name: 'CLOListPage',
                component: CLOListPage,
                children:[
                  {
                    path: ':org',
                    name: 'OrganizationCLOCommonPage',
                    component: OrganizationCLOCommonPage,
                    children: [
                      {
                        path: '',
                      },
                      {
                        path: 'organization-profile',
                        name: 'OrganizationProfilePage',
                        component: OrganizationProfilePage,
                        props:true,

                        meta: {
                          title: 'Pacto | Web Dashboard - Organization Profile 💼'
                        }
                      },
                      {
                        path: 'organization-profile/:edit',
                        name: 'OrganizationProfilePageEdit',
                        component: OrganizationProfilePage,
                        props:true,

                        meta: {
                          title: 'Pacto | Web Dashboard - Organization Profile 💼'
                        }
                      },
                      {
                        path: 'pacto-settings',
                        name: 'PactoSettingsPage',
                        component: PactoSettingsPage,
                        meta: {
                          title: 'Pacto | Web Dashboard - Pacto Settings  💼'
                        }
                      },
                      {
                        path: 'pacto-legal',
                        name: 'PactoLegalPage',
                        component: PactoLegalPage,
                        meta: {
                          title: 'Pacto | Web Dashboard - Pacto Legal  💼'
                        }
                      },

                      {
                        path: 'user-management',
                        name: 'CLOUsersPage',
                        component: CLOUsersPage,
                        meta: {
                          title: 'Pacto | Web Dashboard - CLO-Users 💼'
                        },

                      },
                    ],
                  },
                ],
                meta: {
                  title: 'Pacto | Web Dashboard - CLO List  💼'
                },
              },
            ]
          },
          {
            path: 'support-requests',
            name: 'SupportRequestsPage',
            component: SupportRequestsPage,
            meta: {
              title: 'Pacto | Web Dashboard - Support Requests 💼'
            }
          },
          {
            path: 'clo-chats',
            name: 'CLOChatsPage',
            component: CLOChatsPage,
            meta: {
              title: 'Pacto | Web Dashboard - Chats 💼'
            }
          },


        ]
      },

      {
        path: '/users',
        name: 'UsersPage',
        component: UsersPage,
        meta: {
          title: 'Pacto | Web Dashboard - Users 💼'
        }
      },
      {
        path: '/clo-privacy-policy',
        name: 'PrivacyPolicyPage',
        component: PrivacyPolicyPage,
        meta: {
          title: 'Pacto | Web Dashboard - Privacy Policy & Terms and Conditions  💼'
        }
      },
      {
        path: '/contracts/details/:uuid',
        name: 'ContractSinglePage',
        component: ContractSinglePage,
        meta: {
          title: 'Pacto | Web Dashboard - Contract Details 💼'
        }
      },
      {
        path: '/contracts/templates',
        name: 'ContractTemplatesPage',
        component: ContractTemplatesPage,
        meta: {
          title: 'Pacto | Web Dashboard - Contract Templates 💼'
        }
      },
      {
        path: '/contracts/proposals',
        name: 'ContractProposalsPage',
        component: ContractProposalsPage,
        meta: {
          title: 'Pacto | Web Dashboard - Contract Proposals 💼'
        }
      },
      {
        path: '/contracts/proposals/create',
        name: 'CreateContractProposalPage',
        component: CreateContractProposalPage,
        meta: {
          title: 'Pacto | Web Dashboard - New Contract Proposal 💼'
        }
      },
      {
        path: '/contracts/proposals/:uuid',
        name: 'ContractProposalSinglePage',
        component: ContractProposalSinglePage,
        meta: {
          title: 'Pacto | Web Dashboard - Contract Proposal 💼'
        }
      },
      {
        path: '/contracts/proposals/:uuid/edit',
        name: 'EditContractProposalPage',
        component: EditContractProposalPage,
        meta: {
          title: 'Pacto | Web Dashboard - Edit Contract Proposal 💼'
        }
      },
      {
        path: '/contracts/callback',
        name: 'ContractsPageCallback',
        component: CallbackPage,
        meta: {
          title: 'Pacto | Web Dashboard - Contracts Callback 💼'
        }
      },
      {
        path: '/contracts/issues',
        name: 'IssuesPage',
        component: IssuesPage,
        meta: {
          title: 'Pacto | Web Dashboard - Issues 💼'
        }
      },
      {
        path: '/support',
        name: 'SupportPage',
        component: SupportPage,
        meta: {
          title: 'Pacto | Web Dashboard - Support 💼'
        }
      },
      {
        path: '/enterprise-account',
        name: 'EnterpriseProfilePage',
        component: EnterpriseProfilePage,
        meta: {
          title: 'Pacto | Web Dashboard - Enterprise Profile 💼'
        },
        children:[
          {
            path: ':ent/profile',
            name: 'EnterpriseProfile',
            component: EnterpriseProfile,
            meta: {
              title: 'Pacto | Web Dashboard - Enterprise Profile 💼'
            }
          },
          {
            path: ':ent/users',
            name: 'EnterpriseUsers',
            component: EnterpriseUsers,
            meta: {
              title: 'Pacto | Web Dashboard - Enterprise Users 💼'
            }
          },
          {
            path: ':ent/agreement-terms',
            name: 'AgreementTerms',
            component: AgreementTerms,
            meta: {
              title: 'Pacto | Web Dashboard - Agreement Terms 💼'
            }
          },
          {
            path: ':ent/subscriptions-licenses',
            name: 'SubscriptionsLicenses',
            component: SubscriptionsLicenses,
            meta: {
              title: 'Pacto | Web Dashboard - Subscriptions Licenses 💼'
            }
          },
        ]
      },



      {
        path: '/contracts/issues/:uuid',
        name: 'IssuesSinglePage',
        component: IssuesSinglePage,
        meta: {
          title: 'Pacto | Web Dashboard - Issue Details 💼'
        }
      },
      {
        path: '/houses',
        name: 'HousesPage',
        component: HousesPage,
        meta: {
          title: 'Pacto | Web Dashboard - Houses 💼'
        }
      },
      {
        path: '/conversations',
        name: 'ConversationPage',
        component: ConversationPage,
        meta: {
          title: 'Pacto | Web Dashboard - Conversations 💼'
        }
      },
      {
        path: '/move-in-move-out',
        name: 'MoveInMoveOutPage',
        component: MoveInMoveOutPage,
        meta: {
          title: 'Pacto | Web Dashboard - Conversations 💼'
        }
      },

      {
        path: '/clo-support-request',
        name: 'CLOSupportRequest',
        component: CLOSupportRequest,
        meta: {
          title: 'Pacto | Web Dashboard - Conversations 💼'
        }
      },
      {
        path: '/applications-support',
        name: 'ApplicationsForSupportPage',
        component: ApplicationsForSupportPage,
        meta: {
          title: 'Pacto | Web Dashboard - Applications For Support  💼'
        }
      },
      {
        path: '/user-feedback',
        name: 'UserFeedbackPage',
        component: UserFeedbackPage,
        meta: {
          title: 'Pacto | Web Dashboard - User Feedback   💼'
        }
      },
      {
        path: '/gdpr-requests',
        name: 'GDPRRequestsPage',
        component: GDPRRequestsPage,
        meta: {
          title: 'Pacto | Web Dashboard - GDPR Requests  💼'
        }
      },
      {
        path: '/hints-and-tips',
        name: 'HintsAndTipsPage',
        component: HintsAndTipsPage,
        meta: {
          title: 'Pacto | Web Dashboard - Hints And Tips   💼'
        }
      },
      {
        path: '/privacy-policy',
        name: 'PrivacyPolicyView',
        component: PrivacyPolicyView,
        meta: {
          title: 'Pacto | Web Dashboard - Privacy Policy 💼'
        }
      },
      {
        path: '/support-section-content',
        name: 'SupportSectionContent',
        component: SupportSectionContent,
        meta: {
          title: 'Pacto | Web Dashboard - Privacy Policy 💼'
        },

      },

      {
        path: '/faq',
        name: 'FAQPage',
        component: FAQPage,
        meta: {
          title: 'Pacto | Web Dashboard - FAQ 💼'
        }
      },
      {
        path: '/word-and-phase-blacklisting',
        name: 'WordAndPhaseBlacklistingPage',
        component: WordAndPhaseBlacklistingPage,
        meta: {
          title: 'Pacto | Web Dashboard - Word And Phase Blacklisting  💼'
        }
      },
      {
        path: '/regions-and-countries',
        name: 'RegionsAndCountriesPage',
        component: RegionsAndCountriesPage,
        meta: {
          title: 'Pacto | Web Dashboard - Regions And Countries   💼'
        }
      },
      {
        path: '/languages',
        name: 'LanguagesPage',
        component: LanguagesPage,
        meta: {
          title: 'Pacto | Web Dashboard - Languages   💼'
        }
      },
      {
        path: '/currencies',
        name: 'CurrenciesPage',
        component: CurrenciesPage,
        meta: {
          title: 'Pacto | Web Dashboard - Currencies   💼'
        }
      },
      {
        path: '/houses/:uid',
        name: 'EditHousePage',
        component: EditHousePage,
        meta: {
          title: 'Pacto | Web Dashboard - Edit House 💼'
        }
      },
      {
        path: '/profile',
        name: 'ProfilePage',
        component: ProfilePage,
        meta: {
          title: 'Pacto | Web Dashboard - Profile 💼'
        }
      }
    ]
  },

  {
    path: '/login',
    name: 'LoginPage',
    component: LoginView,
    meta: {
      title: 'Pacto | Web Dashboard - Login 💼'
    }
  },

  {
    path: '/sign-up',
    name: 'SignupPage',
    component: SignupView,
    meta: {
      title: 'Pacto | Web Dashboard - Signup 💼'
    }
  },

  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPasswordView,
    meta: {
      title: 'Pacto | Web Dashboard - Forgot Password 💼'
    }
  },

  {
    path: '/logout',
    name: 'LogoutPage',
    component: LogoutView,
    meta: {
      title: 'Pacto | Web Dashboard - Logout 💼'
    }
  },
  {
    path: '/verifyEmail',
    name: 'VerifyEmail',
    component: VerifyEmailView,
    meta: {
      title: 'Pacto | Web Dashboard - Verify Email 💼'
    }
  },

  {
    path: '/resetPassword',
    name: 'resetPassword',
    component: ResetPasswordView,
    meta: {
      title: 'Pacto | Web Dashboard - Reset Password 💼'
    }
  },
  {
    path: '/:catchAll(.*)',
    redirect: '/'
  }
  ]
})

router.beforeEach((to, from, next) => {
  //Meta and Page Title
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  }

  // Require Login
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!localStorage.getItem('token')) {
      location.href = '/login'
    } else {
      next()
    }
  } else {
    next();
  }
})

export default router
